import React, { Component } from 'react';
import { Form, FormGroup, Label, Col, Row } from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchStates } from '../../../../../../Redux/Actions/CommonActions';
import { getCounties } from '../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { auth } from '../../../../../../services';

import '../../../../../AdminView/Pages/Administration/ManageMembership/ManageMembership.scss';

class InviteUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.email,
      userID: '',
      membershipId: 0,
      MembershipPackageId: 0,
      mailingStateId: 0,
      firstName: "",
      lastName: "",
      mailingAddress1: "",
      mailingAddress2: "",
      mailingCity: "",
      mailingZip: "",
      phone: "",
      memberSequenceNum: 1,
      stateObject: {
        id: 0,
        name: "",
      },
      County: {
        countyId: 0,
        countyName: ""
      },
      isMembershipOwner: false
    };

  }
  componentDidMount() {
    const membershipId = this.props.accountDetails.selectedMember.membershipId;
    this.props.fetchStates();
    this.setState({
      membershipId: membershipId
    })
  }

  onDialogInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    }
      ,
      () => {
        this.props.inviteUserStateChange(this.state);
      });
  }

  handleState = (event) => {
    this.props.getCounties(event.target.value.id);
    this.setState({
      mailingStateId: event.target.value.id,
      stateObject: {
        id: event.target.value.id,
        name: event.target.value.name,
      }
    });
  };
  handleCheckboxChange = event => {

    this.setState({ isMembershipOwner: event.target.checked }
      ,
      () => {
        this.props.inviteUserStateChange(this.state);
      });
  }

  handleCancel = (event) => {
    event.preventDefault();
    this.props.cancel();
  }

  checkForm = (event) => {
    this.props.handleSubmit();
  }

  render() {
    return (
      <form className="additionalMembersForm user-form membership-form">
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="firstName">First Name</label>
            <Input type="firstName" name="firstName" onChange={this.onDialogInputChange} required />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="lastName">Last Name</label>
            <Input type="lastName" name="lastName" onChange={this.onDialogInputChange} required />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="">Address1</label>
            <Input type="text" name="mailingAddress1" onChange={this.onDialogInputChange} required />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="">Address2</label>
            <Input type="text" name="mailingAddress2" onChange={this.onDialogInputChange} />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="city">City</label>
            <Input type="city" name="mailingCity" onChange={this.onDialogInputChange} required />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="state">State</label>
            <DropDownList data={this.props.common.states}
              id="State"
              name="state"
              textField="name"
              dataItemKey="id"
              onChange={this.handleState}
              value={this.state.stateObject}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="County">County</label>
            <DropDownList data={this.props.district.counties}
              id="County"
              name="County"
              textField="countyName"
              dataItemKey="countyId"
              onChange={this.onDialogInputChange}
              value={this.state.CountyObj}
            // className={this.state.touched.state && this.state.CountyObj === null ? "error" : ""}
            //onBlur={this.handleBlur('county')}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="zip">Zip</label>
            <Input type="zip" name="mailingZip" onChange={this.onDialogInputChange} required />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="phone">Phone</label>
            <Input type="phone" name="phone" onChange={this.onDialogInputChange} />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label htmlFor="email">Email</label>
            <Input type="email" name="email" value={this.state.email} onChange={this.onDialogInputChange} required />
          </div>
        </div>
        {auth.isInRole('INTERNAL') && !this.props.isOwner ?
          <div className="membershipOwner">
            <input
              type="checkbox"
              id="IsMembershipOwner"
              name="IsMembershipOwner"
              checked={this.state.isMembershipOwner}
              onChange={this.handleCheckboxChange}
            />
            <label htmlFor="IsMembershipOwner">
              <span className={this.state.isMembershipOwner ? " far fa-check-square" : "far fa-square"}></span>
              <span className="custom-control-text">IsMebership Owner</span>
            </label>
          </div>
          : ""}

        {/* <FormGroup check>
					<Label check>
						<Input type="checkbox" /> Send Subscription
					</Label>
				</FormGroup> */}
        <div className="modal-footer modal-footer-inner">
          <button type="submit" className="btnPrimary admin-k-button" onClick={this.props.checkForm}>
            <i className="fas fa-paper-plane"></i>
            <span>Send Invite</span>
          </button>
          <button className="btn btn-cancel btnSecondary admin-k-button authorizedUsrCancelBtn" onClick={this.handleCancel}>
            <i className="fas fa-times"></i>
            <span>CANCEL</span>
          </button>
        </div>
      </form>
    );
  }
}
function mapStateToProps(state) {
  return {
    common: state.common,
    district: state.district,
    accountDetails: state.accountDetails
  }
}
export default withRouter(connect(mapStateToProps, { fetchStates, getCounties })(InviteUserForm));
